import { includes } from 'lodash/fp';
import styled, { css } from 'styled-components';
import { Z_INDEX_HIGH } from '@mews-ui/theme';
import { StyledTransitionGroup, StyledTransitionGroupProps, TransitionGroupChildBaseProps } from '@optimus-web/helpers';
import {
    ANIMATION_CURVE,
    ANIMATION_DURATION,
    BORDER_RADIUS,
    Component,
    Decision,
    getComponentToken,
    SPACING,
    TransitionState,
} from '@optimus-web/local-tokens';
import { Backdrop } from '../Backdrop';

const getDrawerColorToken = getComponentToken(Component.Drawer);
const getDrawerPillColorToken = getComponentToken(Component.DrawerPill);

export const MIN_SWIPE_DISTANCE = SPACING[300];

export const DrawerWrapper = styled((props: Partial<StyledTransitionGroupProps<TransitionGroupChildBaseProps>>) => (
    <StyledTransitionGroup {...props} />
))`
    position: fixed;
    height: 100%;
    width: 100%;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: ${Z_INDEX_HIGH};
    pointer-events: none;
    overflow: hidden;
`;

export const DrawerBackdrop = styled(Backdrop)<TransitionGroupChildBaseProps>`
    opacity: 0;
    transition: opacity ${ANIMATION_DURATION.default}ms ${ANIMATION_CURVE.default};
    pointer-events: initial;

    ${(props) =>
        includes(props.transitionState, [TransitionState.ENTERING, TransitionState.EXITING]) &&
        css`
            opacity: 0;
        `}
    ${(props) =>
        props.transitionState === TransitionState.ENTERED &&
        css`
            opacity: 1;
        `}
`;

interface DrawerContainerProps {
    opened: boolean;
    height: number;
}

export const DrawerContainer = styled.div<DrawerContainerProps>`
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    transition: transform ${ANIMATION_DURATION.default}ms ${ANIMATION_CURVE.default};
    ${(props) => `transform: translateY(${props.opened ? '0' : '100%'});`}
    height: ${(props) => props.height}%;
    width: 100%;
    pointer-events: initial;
`;

export const DrawerTopSection = styled.div`
    background-color: ${getDrawerColorToken(Decision.BackgroundColor)};
    height: ${MIN_SWIPE_DISTANCE}px;
    border-radius: ${BORDER_RADIUS[100]} ${BORDER_RADIUS[100]} 0 0;
    display: flex;
    justify-content: center;
    align-items: center;
`;

export const DrawerGesturePill = styled.div`
    width: ${SPACING[1200]}px;
    height: ${SPACING[50]}px;
    background-color: ${getDrawerPillColorToken(Decision.BackgroundColor)};
    border-radius: ${BORDER_RADIUS[100]};
`;

export const DrawerContent = styled.div`
    background-color: ${getDrawerColorToken(Decision.BackgroundColor)};
    height: 100%;
    overflow: auto;
`;
